<template>
<div class="main">
  <Header></Header>
  <Context></Context>
</div>
</template>
<script>
import Header from "@/pages/layout/Header"
import Context from "@/pages/layout/Context"

export default {
  name: "Main",
  components: { Header, Context }
}
</script>
<style lang="sass" scoped>
  .main
    width: calc(100% - 200px)
    height: 100%
    margin-left: 200px
    overflow: hidden
</style>



// WEBPACK FOOTER //
// src/pages/layout/Main.vue